import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useScreenSize } from '@/composables/useScreenSize';

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTooltip',
  props: {
    modelValue: { type: Boolean, default: false },
    position: { default: 'top' },
    content: { default: '' },
    trigger: { default: '' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props;

const { isTablet } = useScreenSize();



const currentValue = ref(props.modelValue);
const tooltipRef = ref<any>(null);


const triggerByDevice = computed(() => {
  if (!isTablet.value) {
    return props.trigger;
  }
  return 'click';
});

watch(() => props.modelValue, (newValue) => {
  currentValue.value = newValue;
});

onClickOutside(tooltipRef, () => {
  currentValue.value = false;
  emit('update:modelValue', currentValue.value);
});

return (_ctx: any,_cache: any) => {
  const _directive_close_popper = _resolveDirective("close-popper")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref_key: "tooltipRef",
    ref: tooltipRef
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _withDirectives(_createElementVNode("span", null, null, 512), [
      [_directive_close_popper]
    ])
  ])), [
    [_directive_tooltip, {
      content: _ctx.content,
      html: true,
      shown: currentValue.value && _ctx.content,
      triggers: _ctx.trigger ? [triggerByDevice.value] : [],
      placement: _ctx.position,
    }]
  ])
}
}

})